import axios from "axios";
import qs from "qs";

import apiBasic from "./APIBasic";

//axios版本至1.11.0
export let instance = axios.create({ timeout: 80000, baseURL: apiBasic.url });
// axios的全局配置
instance.defaults.headers.post["Content-Type"] = "application/json";
//跨域存取cookies
instance.defaults.withCredentials = true;

// 儲存進行中的請求
let pendingReq = new Map();

// 生成請求的唯一標識符
const generateRequestKey = (config = {}) => {
  const method = (config.method || "").toLowerCase();
  const url = config.url || "";
  const paramsString = qs.stringify(config.params, {
    arrayFormat: "indices",
    sort: (a, b) => a.localeCompare(b),
    serializeDate: (d) => d.toISOString(),
  });

  return [method, url, paramsString].join("&").toString();
};

// 將請求添加到 pendingReq 中
const addPending = (config) => {
  const key = generateRequestKey(config);
  if (!pendingReq.has(key)) {
    const controller = new AbortController();
    config.signal = controller.signal;
    pendingReq.set(key, controller);
  }
};

// 從 pendingReq 中移除請求
const removePending = (config, shouldAbort = true) => {
  const key = generateRequestKey(config);
  if (pendingReq.has(key)) {
    const controller = pendingReq.get(key);
    if (shouldAbort && controller && typeof controller.abort === "function") {
      controller.abort(key);
    }
    pendingReq.delete(key);
  }
};

// 檢查是否有重複請求
const checkPending = (config) => {
  const key = generateRequestKey(config);
  return pendingReq.has(key);
};

instance.interceptors.request.use(
  function (config) {
    const method = (config.method || "").toLowerCase();
    if (method === "get") {
      config.paramsSerializer = (params) => {
        return qs.stringify(params, { arrayFormat: "indices" });
      };
    }

    // POST：若有進行中的相同請求，直接拒絕新請求，不發送
    if (method === "post") {
      if (checkPending(config)) {
        return Promise.reject({
          code: "PostCanceledError",
          message: generateRequestKey(config),
          name: "PostCanceledError",
        });
      }
      addPending(config);
      return config;
    }

    // ---先暫時不檢查 GET 請求 , 有需要再把這段註解打開---

    // GET 等其他方法：取消舊請求（若存在），立即建立新的 controller
    // if (checkPending(config)) {
    //   removePending(config, true);
    // }
    // addPending(config);
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  async (response) => {
    // 請求完成後從 pendingReq 中移除
    removePending(response.config, false);

    if (response) {
      if (response.data.status === 200) {
        return {
          status: true,
          msg: response.data.msg,
          data: response.data.data,
        };
      } else if (response.data.status === 403) {
        console.log(response.data);
        window.location.assign(`/login`);
      } else {
        return {
          status: false,
          msg: response.data ? response.data.msg : "handlerAPI ->伺服器連接失敗",
          data: response.data.data,
        };
      }
    }
  },
  (err) => {
    const { response, config } = err;

    // 處理重複POST請求的錯誤
    if (err.code === "PostCanceledError") {
      return {
        status: false,
        data: "",
        msg: `POST重複請求 ${err.message}`,
      };
    }

    // 處理請求被取消的錯誤
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      console.log("重複請求", err);
      return {
        status: false,
        data: "",
        msg: "重複請求",
      };
    }

    // 處理請求超時的錯誤
    if (err.code === "ECONNABORTED") {
      if (config) removePending(config, false);
      return {
        status: false,
        data: {},
        msg: "請求逾時",
      };
    }

    if (response) {
      removePending(response.config || config, false);
      return {
        status: false,
        data: "",
        msg: errorHandle(response.status, response.data),
      };
    }

    if (config) removePending(config, false);
    return {
      status: false,
      data: {},
      msg: "請求逾時",
    };
  }
);

const errorHandle = (status, other) => {
  switch (status) {
    case 400:
      return "handlerAPI -> 訊息效驗失敗 400";
    case 401:
      return "handlerAPI ->認證失败 401";
    case 403:
      return "handlerAPI ->403";
    case 404:
      return "handlerAPI ->請求的資源不存在 404";
    default:
      console.log("handlerAPI ->", other);
      return "handlerAPI ->無法辨識的資源";
  }
};
